import Vue from 'vue';
const { $gettext } = Vue.prototype;
export default {
  attributes: {
    /* Article */
    category: 'Nhóm sản phẩm',
    name: 'Tên',
    productGroup: 'Product Group',
    orderLevel: 'Order Level',
    price: 'Giá',
    priceMax: 'Giá cao nhất',
    priceMin: 'Giá thấp nhất',
    quantity: 'Số lượng',
    type: 'Loại sản phẩm',

    /* Stock Item */
    cost: 'Giá mua',
    size: 'Kích cỡ',
    unit: 'Unit',
    managementGroup: 'Management Group',
    count: 'Count',
    alarmLevel: 'Alarm Level',
    standardOrder: 'Reorder',
    stockItemId: 'Sản phẩm kho',
    stockItemName: 'Tên sản phẩm',

    /* Promotion */
    promotionType: 'Loại khuyến mãi',
    value: 'Giá trị',
    subValue: 'Giá trị',
    fromDate: 'Từ',
    toDate: 'Đến',
    startTime: 'Giờ bắt đầu',
    endTime: 'Giờ kết thúc',
    dayOfWeek: 'Ngày trong tuần',
  },
  messages: {
    decimal: (field) => {
      const fieldName = field.includes('quantity') ? 'Số lượng' : field;
      return `${fieldName} không hợp lệ`;
    },
    max_value: (field, [value]) => {
      const fieldName = field.includes('quantity') ? 'Quantity' : field;
      return `${fieldName} phải nhỏ hơn ${value}`;
    },
    numeric: (field) => {
      const fieldName = field.includes('quantity') ? 'Số lượng' : field;
      return `${fieldName} không hợp lệ`;
    },
    required: field => `Vui lòng nhập ${field}`,
    required_if: field => `Vui lòng nhập ${field}`,
  },
};
